export const TIINY_STYLE_ID = 'tiiny-style';

const EDITOR_CSS = `
.tiinyeditableimage {
  cursor: pointer;
  border: 2px dashed #6e2f9a !important;
}

.tiinyeditabletext {
  cursor: pointer;
  box-shadow: inset 0px 0px 0px 2px #e0b4ff;
  background: #ffddff;
}

.tiinyeditablefocused {
  background: transparent;
}
`;

export function injectEditorStyles(iframeDoc) {
  if (iframeDoc.getElementById(TIINY_STYLE_ID)) return;

  const style = iframeDoc.createElement('style');
  style.id = TIINY_STYLE_ID;
  style.textContent = EDITOR_CSS;
  iframeDoc.head.appendChild(style);
}

export function removeEditorStyles(iframeDoc) {
  const style = iframeDoc.getElementById(TIINY_STYLE_ID);
  if (style) {
    style.remove();
  }
}
